document.addEventListener('mouseover', function(e) {
  var switcher = document.querySelector('.header__localization sht-localization');
  if (!switcher) return;
  if (!switcher.contains(e.target)) {
    var list = switcher.querySelector('.js-language-switcher-language-list');
    var btn = switcher.querySelector('.js-language-switcher-btn');
    if (list && list.classList.contains('is-open')) {
      list.classList.remove('is-open');
      list.hidden = true;
      if (btn) btn.setAttribute('aria-expanded', 'false');
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('touchend', function(e) {
    var btn = e.target.closest('.js-language-switcher-btn');
    if (!btn) return;

    var switcher = btn.closest('sht-localization');
    if (!switcher) return;
    var list = switcher.querySelector('.js-language-switcher-language-list');

    if (list && list.classList.contains('is-open')) {
      e.preventDefault();
      e.stopPropagation();
      list.classList.remove('is-open');
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      var header = document.querySelector('.header--transparent');
      if (header) header.classList.remove('header-menu--open');
    }
  }, { passive: false });
});

document.addEventListener('scroll', function() {
  var list = document.querySelector('.js-language-switcher-language-list.is-open');
  if (list) {
    var btn = document.querySelector('.js-language-switcher-btn');
    list.classList.remove('is-open');
    list.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    var header = document.querySelector('.header--transparent');
    if (header) header.classList.remove('header-menu--open');
  }
});